export default __webpack_public_path__ + "static/media/B207.bd97170e.png";